import { render, staticRenderFns } from "./TestimonialsComponent.vue?vue&type=template&id=25140ca8&"
import script from "./TestimonialsComponent.vue?vue&type=script&lang=js&"
export * from "./TestimonialsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports